import styled from 'styled-components';
import NumericInput from '../utils/inputs/NumericInput/NumericInput';

export const Button = styled.button`
  border-radius: 12px;
  background: #1672ba;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  position: relative;
  width: 3.2rem;
  height: 3.2rem;
`;

export const TooltipContainer = styled.form`
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  z-index: 1000;
  display: flex;
  flex-direction: column;

  padding: 1.6rem 1.6rem 1.2rem 1.6rem;
  width: 32.5rem;
  position: absolute;
  top: 3.2rem;
  right: -1rem;
`;

export const NumberInput = styled(NumericInput)`
  width: unset;
  margin-top: 1.2rem;
  input {
    padding: 1.4rem 1.6rem;
    padding-left: 2rem;
  }
  span {
    top: 3.7rem;
    font-size: 1.5rem;
  }
`;

export const StyledButton = styled(Button)`
  width: 13rem;
  height: unset;
  margin-inline: auto;
  padding: 1.2rem 2.4rem;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: -0.42px;
`;
